/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import Autolinker from 'autolinker';

import { CAPTURE_MAX_HEIGHT } from '../../constants/styles';

import ReadMoreBtn from '../common/ReadMoreBtn';

import sanitizeHtml from '../../utils/sanitizeHtml';

import styles from './index.styl';

@CSSModules(styles, { allowMultiple: true })
export default class Body extends Component {
  static propTypes = {
    content: PropTypes.string,
    redirect: PropTypes.func,
    disabled: PropTypes.bool,
    className: PropTypes.string,
  };

  capture = null;
  timeoutId;
  state = {
    shortened: false,
  };

  componentDidMount() {
    this.handleCaptureView();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.content !== this.props.content) {
      this.handleCaptureView();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  handleCaptureView() {
    // hack for mobile layout repainting
    const self = this;

    this.timeoutId = setTimeout(() => {
      const { capture } = self;
      const shortened = capture && capture.offsetHeight > CAPTURE_MAX_HEIGHT;

      self.setState({ shortened });
    }, 0);
  }

  render() {
    const { shortened } = this.state;
    const { content, redirect, disabled, className } = this.props;

    const validContent = content && content !== 'null' ? content : '';

    const style = {
      maxHeight: redirect && CAPTURE_MAX_HEIGHT,
      overflow: 'hidden',
    };

    return (
      <div styleName="body" className={className}>
        <div {...{ style }}>
          <div
            styleName="body__content"
            ref={node => (this.capture = node)}
            dangerouslySetInnerHTML={{
              // eslint-disable-line react/no-danger
              __html: Autolinker.link(sanitizeHtml(validContent), {
                className: 'clickable',
              }),
            }}
          />
        </div>
        <If condition={redirect && shortened}>
          <ReadMoreBtn onClick={redirect} className="mt2" disabled={disabled} />
        </If>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PostPreview/Body.jsx